module.exports = "\r\n<div class=\"qrcode-body\">\r\n  <div class=\"qrcode-title\">钉钉登录</div>\r\n  <div class=\"qrcode-container\" id=\"dd-qrcode-container\">\r\n  </div>\r\n  <div class=\"qrcode-footer\">\r\n    使用钉钉扫码登录\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/ddLogin/DDLogin.html
// module id = 112
// module chunks = 0